
/* ------------------------------------------------------------------------ */
/*		File: Homwe.tsx                                                     */
/*		Description: Home page definition                                   */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */
import "./home.css";
import React, { useState } from "react";
import Slider from "react-slick";
import Card_180 from "../../components/cmpCard_180/Card_180";
import { useTranslation, withTranslation } from "react-i18next";
import { ICmpCard_545 } from "../../components/cmpCard_545/cmpCard_545.d";
import Card_545 from "../../components/cmpCard_545/cmpCard_545";
import Step from "../../components/cmpStep/cmpStep";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getImage } from "../../components/GenericComponents/functions";
import Card_310 from "../../components/cmpCard_310/cmpCard_310";
import { Helmet } from 'react-helmet-async';
import Meta from "../../components/GenericComponents/meta";


/* ------------------------------------------------------------------------ */


const Home: React.FC = () => {
    const { t } = useTranslation();
    const [slider, setSlider] = useState<any>(null);
    
    const home = t("home.content", { returnObjects: true });
    const home_contents: any[] = []; 
    if (Array.isArray(home)) { home.forEach(el => {home_contents.push(el)}) };
    const first_row_cards = home_contents[0].content;
    const second_row_cards = home_contents[1].content;

    home_contents[2].content.sort((a: { position: any; }, b: { position: any; }) => { return (a.position! < b.position! ?  -1 : 0)})

 
    const sliderSettings = {
        arrows: false,
        dots: false, 

        centerMode: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4, 
        speed: 500,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1
                }
            }
        ]
    }
    
    return (
      <div className="home">
        <Meta page={"home"} />
            <div className="first_row">
                {first_row_cards?.map((card: any, i: number) => {
                    return(
                        <Card_180
                            key={`card-180-${i}`}
                            card={card}
                        />
                )
            })}

            </div>

            <div className="second_row">
                <p className="second_row_header">{home_contents[1].label}</p>
                <div className="second_row_contents">
                    {second_row_cards?.map((card: ICmpCard_545, i: number) => {
                        return(
                            <Card_545
                                key={i}
                                card={card}
                            />
                        )
                    })}
                </div>
            </div>
            <div className="third_row">
                <p className="third_row_header">{home_contents[2].label}</p>
                <div className="third_row_contents"> 
                    {home_contents[2].content.map((item:any, index:number) => (
                        <Step
                            key={`infoApplyNow-${index}`}
                            description={item.description}
                            src={item.src}
                        />
                    ))}
                </div>
            </div>
          

            <div className="fourth_row">
                <p className="third_row_header">{home_contents[3].label}</p>
                <div className="cssRowBetween">
                    <div className="cssSliderContainer">
                        <button
                            className="card_about_button left"
                            onClick={() => slider?.slickPrev()}
                        >
                            <img src={getImage("chevron-left.svg")} alt="chevron-left.svg"/>
                        </button>
                        <button
                            className="card_about_button right"
                            onClick={() => slider?.slickNext()}
                        >
                            <img src={getImage("chevron-right.svg")} alt="chevron-right.svg"/>
                        </button>
                        <Slider  ref={(c: any) => setSlider(c)}{...sliderSettings}> 
                            {home_contents[3].content.map((item:any, index:number) => (
                                <Card_310
                                    key={`Card_310-testimonials-${index}`}
                                    card={item}
                                />
                            ))}  
                        </Slider>
                    </div>
                </div>                
            </div>
            

        </div>
    );  
};

export default withTranslation('translation', { withRef: true }) (Home); 